import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { NotFoundScreen } from '@/common/ErrorScreen';
import CoordinatorFollowUpsTable from '@/tables/CoordinatorFollowUpsTable';
import PartnerFollowUpsTable from '@/tables/PartnerFollowUpsTable';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper, Title } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-ups/entries/')({
  component: FollowUpEntriesScreen,
});

/**
 * The *Follow-ups* subnav of both follow-up portals — legacy's `entries` slug,
 * `.../follow-up-coordinator-group/follow-ups/entries/entries.php:4` and
 * `.../follow-up-partner-group/follow-ups/entries/entries.php:3`, which share
 * the heading *Follow-ups*.
 *
 * L2 — the two tables are ONE query with two scopes (`coordinator_id = me` /
 * `partner_id = me`); they are two components because the endpoints publish two
 * schemas.
 *
 * NO *Create Follow-up* header button. Legacy's is wrapped in
 * `<?php if (false): // remove for now ?>` (`entries.php:6-10`), its only link
 * target `entries/new` appears nowhere else in the tree, and that page's own
 * inline map script is a syntax error (`new.php:122`) — building it would ship
 * the first working version of a page the legacy team switched off. The partner
 * tab never had one.
 */
function FollowUpEntriesScreen() {
  const { t } = useTranslation();
  const { me, isPending } = useCurrentUser();

  const isCoordinator = me?.profile_type === 'FOLLOWUP_COORDINATOR';
  const isPartner = me?.profile_type === 'FOLLOWUP_PARTNER';

  // ADMIN deliberately absent — DIV-2, and see the sibling queue route.
  if (isPending) return null;
  if (!isCoordinator && !isPartner) return <NotFoundScreen />;

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        {/* A bare `Title` — see the sibling queue route: legacy's
            `wbs_contextual_helper` is a WordPress entity with no v3 analogue. */}
        <Title>{t('wbs.follow-ups')}</Title>
      </GroupHeaderWrapper>
      {isCoordinator ? (
        <CoordinatorFollowUpsTable />
      ) : (
        <PartnerFollowUpsTable />
      )}
    </PageContainer>
  );
}
